export default __webpack_public_path__ + "static/media/35.279ab196.png";